var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDroneWithCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "63px",
    viewBox: "0 0 64 63",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 17")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.4582309,1.95399252e-13 C36.4137289,1.95399252e-13 46.9164618,10.502388 46.9164618,23.4582309 C46.9164618,36.4137289 36.4137289,46.9164618 23.4582309,46.9164618 C10.502388,46.9164618 1.95399252e-13,36.4137289 1.95399252e-13,23.4582309 C1.95399252e-13,10.502388 10.502388,1.95399252e-13 23.4582309,1.95399252e-13 L23.4582309,1.95399252e-13 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.3%",
    y: "-21.1%",
    width: "150.6%",
    height: "150.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.87665847,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.121568627   0 0 0 0 0.145098039   0 0 0 0 0.156862745  0 0 0 0.35 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-2282.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(2282.220637, 615.624055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.500000, 32.500000) rotate(28.000000) translate(-32.500000, -32.500000) translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drone",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Avatar"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 1.87665847,
    d: "M23.4582309,-0.938329236 C36.9320708,-0.938329236 47.854791,9.98428004 47.854791,23.4582309 C47.854791,36.9319538 36.9319538,47.854791 23.4582309,47.854791 C9.98428004,47.854791 -0.938329236,36.9320708 -0.938329236,23.4582309 C-0.938329236,9.98416303 9.98416303,-0.938329236 23.4582309,-0.938329236 Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.398094,18.6680048 L40.8060586,18.0278081 C40.7500371,18.0199459 40.6929272,18.0300273 40.643052,18.0565304 L39.4046885,18.7142268 C39.2697887,18.5859592 39.0871265,18.5067668 38.8853851,18.5067668 C38.471018,18.5067668 38.1350169,18.8395144 38.1350169,19.2499327 L38.1350169,19.2853125 L32.3027613,19.2853125 C32.1555688,19.2853125 32.036291,19.4034988 32.036291,19.5491392 L32.036291,19.88176 C32.036291,20.0132612 32.1340566,20.1247266 32.2656271,20.1430506 L36.8575344,20.7831839 C36.9136199,20.7909826 36.9707298,20.7809647 37.020605,20.7544616 L38.1350169,20.1626426 L38.1350169,22.5882508 L31.142956,22.5882508 C29.85651,22.5882508 29.2847704,21.5737764 28.3556457,20.4177829 C27.4265849,19.261726 26.0686875,19.379722 26.0686875,19.379722 L25.3301639,19.379722 L23.9245681,19.379722 L23.1860445,19.379722 C23.1860445,19.379722 21.8281471,19.261726 20.8990863,20.4177829 C19.9699616,21.5737764 19.398158,22.5882508 18.111712,22.5882508 L11.2268922,22.5882508 L11.2268922,19.5256795 L16.9519706,19.5256795 C17.0990991,19.5256795 17.2183769,19.4075566 17.2183769,19.2618528 L17.2183769,18.9292954 C17.2183769,18.7977942 17.1206114,18.6863288 16.9891049,18.6680048 L12.3971336,18.0278081 C12.3411121,18.0199459 12.2839381,18.0300273 12.234127,18.0565304 L10.9956994,18.7142268 C10.8608637,18.5859592 10.6781375,18.5067668 10.47646,18.5067668 C10.0620289,18.5067668 9.72602788,18.8395144 9.72602788,19.2499327 L9.72602788,19.2853125 L3.8937723,19.2853125 C3.7466438,19.2853125 3.627366,19.4034988 3.627366,19.5491392 L3.627366,19.88176 C3.627366,20.0132612 3.72513154,20.1247266 3.85663804,20.1430506 L8.44860935,20.7831839 C8.50469489,20.7909826 8.5617408,20.7809647 8.61167997,20.7544616 L9.72602788,20.1626426 L9.72602788,22.6009317 C9.0135623,22.6934391 8.46339903,23.2966075 8.46339903,24.027346 C8.46339903,24.8222501 9.11401687,25.4665681 9.91656505,25.4665681 L13.9524188,25.4665681 C13.9813579,25.4853359 14.0125379,25.5014407 14.046599,25.5125999 C14.2253556,25.571059 14.4886247,25.7007215 14.8241776,25.9855352 C15.3810634,26.4582168 16.4858076,27.4077648 16.8355739,27.7085564 C16.9058089,27.7689811 16.9956994,27.8022051 17.0887272,27.8022051 L17.3791427,27.8022051 C17.5092406,27.8022051 17.6306313,27.8670681 17.7020187,27.9747926 L19.5815884,30.8112628 C19.5868384,30.8191884 19.5922805,30.826797 19.5981708,30.8342787 C19.6972808,30.9609612 20.5822287,32.0252082 22.3522524,32.0252082 L24.2265721,32.0252082 L24.4963077,32.0252082 L24.7583603,32.0252082 L24.893004,32.0252082 L26.9024156,32.0252082 C28.6698143,32.0252082 29.5548261,30.9641948 29.656113,30.8348494 C29.6622594,30.8270506 29.6679576,30.8189982 29.6733997,30.8106922 L31.5475914,27.9824645 C31.62218,27.8699213 31.7488847,27.8022051 31.8848729,27.8022051 L32.1596024,27.8022051 C32.2567277,27.8022051 32.3505237,27.7675862 32.4238959,27.7044985 C32.7787841,27.3992686 33.8761655,26.4561244 34.4305544,25.9855352 C34.7640585,25.7024334 35.0261111,25.5726441 35.2048037,25.5137412 C35.2390569,25.5023917 35.2702369,25.4857797 35.299176,25.4665681 L39.3381029,25.4665681 C40.1407151,25.4665681 40.7912689,24.8222501 40.7912689,24.027346 C40.7912689,23.3336358 40.2955906,22.754688 39.6358813,22.6186216 L39.6358813,19.5256795 L45.3609597,19.5256795 C45.5080882,19.5256795 45.627366,19.4075566 45.627366,19.2618528 L45.627366,18.9292954 C45.627366,18.7977942 45.5296005,18.6863288 45.398094,18.6680048",
    id: "Fill-1",
    fill: "#88B5DD",
    mask: "url(#mask-2)",
    transform: "translate(24.627366, 25.025208) rotate(-28.000000) translate(-24.627366, -25.025208) "
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDroneWithCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drone_with_circle.350284a8.svg";
export { ForwardRef as ReactComponent };